import { render, staticRenderFns } from "./SelectStaff.vue?vue&type=template&id=4dfb5173&scoped=true"
import script from "./SelectStaff.vue?vue&type=script&lang=js"
export * from "./SelectStaff.vue?vue&type=script&lang=js"
import style0 from "./SelectStaff.vue?vue&type=style&index=0&id=4dfb5173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb5173",
  null
  
)

export default component.exports